import { ReactNode } from 'react';
import ServicesBlockItem from './ServicesBlockItem';
import CustomHeading from 'components/UIComponents/Typography/Heading';

import TelegramImage from '../../assets/images/MainPageImages/telegram.png';
import IpImage from '../../assets/images/MainPageImages/IP.webp';
import EmailImage from '../../assets/images/MainPageImages/email.png';

import './ServicesBlockStyles.css';
import MainPageSection from 'components/Layout/MainPageSection';
import { FormattedMessage, useIntl } from 'react-intl';

type ServiceBlockItem = {
  image?: ReactNode;
  heading: string;
  text: string;
  link?: JSX.Element;
  isReady: boolean;
  path?: string;
};

const ServicesBlock = () => {
  const intl = useIntl();

  const items: ServiceBlockItem[] = [
    {
      image: <img src={IpImage} alt="IP" width="150" height="150" />,
      heading: intl.formatMessage({ id: 'IpVerification' }),
      text: intl.formatMessage({ id: 'IpVerificationDescr' }),
      isReady: true,
      path: '/tools/ip-check',
    },
    {
      image: <img src={EmailImage} alt="email" width="150" height="150" />,
      heading: intl.formatMessage({ id: 'EmailVerification' }),
      text: intl.formatMessage({ id: 'EmailVerificationDescr' }),
      isReady: false,
      path: '/tools/email-check',
    },
    {
      image: <img src={TelegramImage} alt="telegram" width="150" height="150" />,
      heading: intl.formatMessage({ id: 'TelegramCheck' }),
      text: intl.formatMessage({ id: 'TelegramCheckDescr' }),
      isReady: false,
      path: '/tools/telegram-check',
    },
  ];

  return (
    <MainPageSection>
      <div className="services-block">
        <CustomHeading className="section-heading services-block-heading ">
          <FormattedMessage id="WeProvideText" />
        </CustomHeading>
        <div className="services-block-body">
          {items.map((item, index) => (
            <ServicesBlockItem key={index} item={item} />
          ))}
        </div>
      </div>
    </MainPageSection>
  );
};

export default ServicesBlock;
